export function ObterLocalizacao() {
  try{
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(SalvarLocalizacao);
    } else {
      alert("A geolocalização não é compatível com este navegador.");
    }
  }catch (e){}
}

export function SalvarLocalizacao(position) {
  let lat = position.coords.latitude;
  let lng = position.coords.longitude;
  localStorage.setItem('localizacao',lat + ','+lng);
}



// WEBPACK FOOTER //
// ./src/services/localizacao.js